import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ncoder/ui';
import { ScenarioCard } from '../../atoms/testing/ScenarioCard';

interface TestScenariosProps {
  onScenarioClick?: (scenario: string) => void;
}

export const TestScenarios: React.FC<TestScenariosProps> = ({
  onScenarioClick,
}) => {
  const scenarios = [
    { id: 'support', title: 'Customer Support', description: 'Test support scenarios' },
    { id: 'product', title: 'Product Queries', description: 'Test product knowledge' },
    { id: 'edge-cases', title: 'Edge Cases', description: 'Test unusual inputs' },
    { id: 'multi-turn', title: 'Multi-turn Conversations', description: 'Test context retention' },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Test Scenarios</CardTitle>
        <CardDescription>Predefined test scenarios for your agent</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {scenarios.map((scenario) => (
            <ScenarioCard
              key={scenario.id}
              title={scenario.title}
              description={scenario.description}
              onClick={() => onScenarioClick?.(scenario.id)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
